import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import EfIcon from '@elem/ui/ef-icon';

export default function TheComp() {
    const { t } = useLang('rapid.OtherB');
    return (
        <div className={`${css.comp} rapid-C`}>
            <EfSpec />
            <p className="text">{t('title')}</p>
            <div className="wrapper pc">
                <div className="l">
                    <div className="l-t card">
                        <div className="img">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729502449157/2_1.png" />
                        </div>
                        <div className="info">
                            <p className="title">
                                {t.rich('item1_title', {
                                    text1: (text: string) => <span>{text}</span>,
                                    text2: (text: string) => <span className="unit">{text}</span>,
                                    text3: (text: string) => <span className="split">{text}</span>,
                                    text4: (text: string) => <span>{text}</span>,
                                    text5: (text: string) => <span className="unit">{text}</span>,
                                })}
                            </p>
                            <p className="desc">{t('item1_desc')}</p>
                        </div>
                    </div>
                    <div className="l-b card">
                        <div className="img">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729503183179/2_2%20(1).jpg" />
                        </div>
                        <div className="info">
                            <div className="desc">{t('item4_desc')}</div>
                            <div className="title">{t('item4_title')}</div>
                            <div className="desc">{t('item4_desc2')}</div>
                        </div>
                    </div>
                </div>
                <div className="r">
                    <div className="r-t">
                        <div className="r-t-l card">
                            <div className="img">
                                <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729504050773/2_3%20(1).jpg" />
                            </div>
                            <div className="info">
                                <p className="title">
                                    {t.rich('item2_title', {
                                        text1: (text: string) => <span>{text}</span>,
                                        text2: (text: string) => <span className="unit">{text}</span>,
                                    })}
                                </p>
                                <p className="desc">{t('item2_desc')}</p>
                                <div className="icon">
                                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1725431644756/m_ksp_02.svg" />
                                </div>
                            </div>
                        </div>
                        <div className="r-t-r card">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729504199281/2_4%20(1).jpg" />
                            <div className="info">
                                <div className="title">
                                    {t.rich('item3_title', {
                                        text1: (text: string) => <span>{text}</span>,
                                        text2: (text: string) => <span className="big">{text}</span>,
                                        text3: (text: string) => <span className="unit">{text}</span>,
                                    })}
                                </div>
                                <div className="desc">
                                    {t.rich('item3_desc', {
                                        text1: (text: string) => <span>{text}</span>,
                                        text2: (text: string) => <span className="bigger">{text}</span>,
                                        text3: (text: string) => <span className="big">{text}</span>,
                                        text4: (text: string) => <sup>{text}</sup>,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="r-b">
                        <div className="r-b-l card">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729505482235/pc_ksp_05.jpg" />
                            <div className="info">
                                <div className="title">{t('item5_title')}</div>
                                <div className="desc">{t('item5_desc')}</div>
                            </div>
                        </div>
                        <div className="r-b-m card">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729505469620/pc_ksp_06.jpg" />
                            <div className="info">
                                <div className="desc">{t('item6_desc')}</div>
                                <div className="title">{t('item6_title')}</div>
                            </div>
                        </div>
                        <div className="r-b-r card">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729505469335/pc_ksp_07.jpg" />
                            <div className="info">
                                <div className="title">{t('item7_title')}</div>
                                <div className="desc">
                                    {t.rich('item7_desc', {
                                        text1: (text: string) => <span className="name">{text}</span>,
                                        text2: (text: string) => <span className="unit">{text}</span>,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrapper h5">
                <div className="l1 card">
                    <div className="img">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729502449157/2_1.png" />
                    </div>
                    <div className="info">
                        <p className="title">
                            {t.rich('item1_title', {
                                text1: (text: string) => <span>{text}</span>,
                                text2: (text: string) => <span className="unit">{text}</span>,
                                text3: (text: string) => <span className="split">{text}</span>,
                                text4: (text: string) => <span>{text}</span>,
                                text5: (text: string) => <span className="unit">{text}</span>,
                            })}
                        </p>
                        <p className="desc">{t('item1_desc')}</p>
                    </div>
                </div>
                <div className="l2">
                    <div className="l2-l card">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512189407/m_ksp_07.jpg" />
                        <div className="info">
                            <div className="title">{t('item7_title')}</div>
                            <div className="desc">
                                {t.rich('item7_desc', {
                                    text1: (text: string) => <span>{text}</span>,
                                    text2: (text: string) => <span className="unit">{text}</span>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="l2-r card">
                        <div className="img">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512211321/m_ksp_02.jpg" />
                        </div>
                        <div className="info">
                            <p className="title">
                                {t.rich('item2_title', {
                                    text1: (text: string) => <span>{text}</span>,
                                    text2: (text: string) => <span className="unit">{text}</span>,
                                })}
                            </p>
                            <p className="desc">{t('item2_desc')}</p>
                            <div className="icon">
                                <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1725431644756/m_ksp_02.svg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="l3">
                    <div className="l3-l card">
                        <div className="img">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512188873/m_ksp_04.jpg" />
                        </div>
                        <div className="info">
                            <div className="desc">{t('item4_desc')}</div>
                            <div className="title">{t('item4_title')}</div>
                            <div className="desc">{t('item4_desc2')}</div>
                        </div>
                    </div>
                    <div className="l3-r card">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512189588/m_ksp_05.jpg" />
                        <div className="info">
                            <div className="title">{t('item5_title')}</div>
                            <div className="desc">{t('item5_desc')}</div>
                        </div>
                    </div>
                </div>
                <div className="l4">
                    <div className="l4-l card">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512189232/m_ksp_03.jpg" />
                        <div className="info">
                            <div className="title">
                                {t.rich('item3_title', {
                                    text1: (text: string) => <span>{text}</span>,
                                    text2: (text: string) => <span className="big">{text}</span>,
                                    text3: (text: string) => <span className="unit">{text}</span>,
                                })}
                            </div>
                            <div className="desc">
                                {t.rich('item3_desc', {
                                    text1: (text: string) => <span>{text}</span>,
                                    text2: (text: string) => <span className="bigger">{text}</span>,
                                    text3: (text: string) => <span className="big">{text}</span>,
                                    text4: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="l4-r card">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1729512189769/m_ksp_06.jpg" />
                        <div className="info">
                            <div className="desc">{t('item6_desc')}</div>
                            <div className="title">{t('item6_title')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
